import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

export default function UnsubscribedPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
          <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
          
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
            {t('unsubscribed.title')}
          </h1>
          
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            {t('unsubscribed.message')}
          </p>
          
          <p className="text-sm text-gray-500 dark:text-gray-500 mb-8">
            {t('unsubscribed.resubscribe')}
          </p>
          
          <Link 
            to="/"
            className="inline-block bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700"
          >
            {t('unsubscribed.backToHome')}
          </Link>
        </div>
      </div>
    </div>
  );
}